import { ProfileSection } from './profile-section'

type Props = {
  companyName: string
  description: string | null
}

export function ProfileDescription({ companyName, description }: Props) {
  if (!description) return null
  return (
    <ProfileSection title={`About ${companyName}`}>
      <p className='whitespace-pre-line text-sm leading-relaxed text-foreground'>
        {description}
      </p>
    </ProfileSection>
  )
}
